import React, { useEffect, useState } from 'react'
import { PureAutocomplete } from 'elentari'

const CustomAutocomplete = ({ input, meta, options, showError, ...props }) => {
  const [value, setValue] = useState()
  useEffect(() => {
    const fetch = async () => {
      const option = options.find(o => o.value === input.value) || ''
      setValue(option)
    }
    fetch()
  }, [input.value, options])

  const onChange = item => {
    setValue(item)
    input.onChange(item ? item.value : '')
  }

  const touched = meta.touched || showError

  return (
    <PureAutocomplete
      {...props}
      meta={meta}
      error={meta.error && touched}
      textFieldProps={{
        onBlur: input.onBlur,
        helperText: touched && meta.error,
        error: meta.error && touched,
        InputLabelProps: {
          shrink: !!input.value || input.dirty
        }
      }}
      helperText={touched && meta.error}
      options={options}
      onChange={onChange}
      value={value}
    />
  )
}

export default CustomAutocomplete
